import { useIntl } from "react-intl";

const AnnouncementBanner = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.announcementBanner.title",
            defaultMessage: "Announcement banner"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.announcementBanner.content",
            defaultMessage:
                "Create and manage critical announcements to ensure important messages are seen where your teams are actually working."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.announcementBanner.altText",
            defaultMessage: "Example of an announcement banner in confluence"
        }),
        imageCaption: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.announcementBanner.imageCaption",
            defaultMessage:
                "Here’s what an announcement banner looks like in Confluence."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            {messages.content}
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Announcement_Banner.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.imageCaption}</p>
        </div>
    );
};

export default AnnouncementBanner;
